// extracted by mini-css-extract-plugin
module.exports =  {"menuItem":"style-module_menuItem__mkCgnPkJoAiXCjVInPxG","content":"style-module_content__pGP9_2Wf8GMqZG6rsEF0"};